import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    UPLOAD_PROFILE_PIC,
    UPLOAD_AADHARCARD_PIC,
    ANALYTICS_LIST,
    ANALYTICS_CHANGE_STATUS,
    ANALYTICS_ADDEDIT,
    ANALYTICS_GETONE,
    ANALYTICS_DELETE,
    LIST_DISTRICT,
    LIST_TALUKA,
    LIST_VILLAGE,
    EDUCATION_WOP_LIST,
    OCCUPATION_WOP_LIST,
    FAMILY_LIST,
    FAMILY_ADDEDIT,
    FAMILY_GETONE,
    FAMILY_DELETE,
    RELATION_WOP_LIST,
    USER_APPROVE_REJECT,
    USER_REJECT,
    USER_EXPORT,
    RESULT_EXPORT
} from "../../api/constApi";
import {
    uploadPofilePicApi,
    uploadAadharCardPicApi,
    userAnalyticsListApi,
    userAnalyticsChangeStatusApi,
    AddEditUserAnalyticsApi,
    GetOneUserAnalyticsApi,
    UserAnalyticsDeleteApi,
    GetAllDistrictApi,
    GetAllTalukaApi,
    GetAllVillageApi,
    GetAllEducationApi,
    GetAllOccupationApi,
    familyListApi,
    AddEditFamilyApi,
    GetOneFamilyApi,
    familyDeleteApi,
    GetAllRelationApi,
    UserApproveRejectApi,
    UserRejectApi,
    UserExportApi,
    ResultExportApi
} from "../Services/userAnalyticsService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const uploadProfilePic = createAsyncThunk(UPLOAD_PROFILE_PIC, async (payload) => {
    const response = await uploadPofilePicApi(payload);
    return response.data;
});

export const uploadAadharcardPic = createAsyncThunk(UPLOAD_AADHARCARD_PIC, async (payload) => {
    const response = await uploadAadharCardPicApi(payload);
    return response.data;
});

export const userAnalyticsList = createAsyncThunk(ANALYTICS_LIST, async (payload) => {
    const response = await userAnalyticsListApi(payload);
    return response.data;
});

export const userAnalyticsChangeStatus = createAsyncThunk(ANALYTICS_CHANGE_STATUS, async (payload) => {
    const response = await userAnalyticsChangeStatusApi(payload);
    return response.data;
});

export const deleteUserAnalytics = createAsyncThunk(ANALYTICS_DELETE, async (payload) => {
    const response = await UserAnalyticsDeleteApi(payload);
    return response.data;
});

export const addEditUserAnalytics = createAsyncThunk(
    ANALYTICS_ADDEDIT,
    async (payload, { rejectWithValue }) => {
        try {
            const response = await AddEditUserAnalyticsApi(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getOneUserAnalytics = createAsyncThunk(ANALYTICS_GETONE, async (payload) => {
    const response = await GetOneUserAnalyticsApi(payload);
    return response.data;
});

export const getDistrictList = createAsyncThunk(LIST_DISTRICT, async (payload) => {
    const response = await GetAllDistrictApi(payload);
    return response.data;
});
export const getTalukaList = createAsyncThunk(LIST_TALUKA, async (payload) => {
    const response = await GetAllTalukaApi(payload);
    return response.data;
});
export const getVillageList = createAsyncThunk(LIST_VILLAGE, async (payload) => {
    const response = await GetAllVillageApi(payload);
    return response.data;
});

export const getEducationList = createAsyncThunk(EDUCATION_WOP_LIST, async (payload) => {
    const response = await GetAllEducationApi(payload);
    return response.data;
});

export const getOccupationList = createAsyncThunk(OCCUPATION_WOP_LIST, async (payload) => {
    const response = await GetAllOccupationApi(payload);
    return response.data;
});

export const getRelationList = createAsyncThunk(RELATION_WOP_LIST, async (payload) => {
    const response = await GetAllRelationApi(payload);
    return response.data;
});

export const familyList = createAsyncThunk(FAMILY_LIST, async (payload) => {
    const response = await familyListApi(payload);
    return response.data;
});

export const addEditFamily = createAsyncThunk(FAMILY_ADDEDIT, async (payload) => {
    const response = await AddEditFamilyApi(payload);
    return response.data;
});

export const getOneFamily = createAsyncThunk(FAMILY_GETONE, async (payload) => {
    const response = await GetOneFamilyApi(payload);
    return response.data;
});
export const deleteFamily = createAsyncThunk(FAMILY_DELETE, async (payload) => {
    const response = await familyDeleteApi(payload);
    return response.data;
});

export const userApproveReject = createAsyncThunk(USER_APPROVE_REJECT, async (payload) => {
    const response = await UserApproveRejectApi(payload);
    return response.data;
});

export const userReject = createAsyncThunk(USER_REJECT, async (payload) => {
    const response = await UserRejectApi(payload);
    return response.data;
});

export const userExport = createAsyncThunk(USER_EXPORT, async (payload) => {
    const response = await UserExportApi(payload);
    return response.data;
});

export const resultExport = createAsyncThunk(RESULT_EXPORT, async (payload) => {
    const response = await ResultExportApi(payload);
    return response.data;
});

export const userAnalyticsSlice = createSlice({
    name: "userAnalytics",
    initialState: {
        userAnalytics: null,
        family: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(userAnalyticsList.fulfilled, (state, action) => {
            state.userAnalytics = action?.payload;
        });
        builder.addCase(addEditUserAnalytics.fulfilled, (state, action) => {
            state.userAnalytics = action?.payload?.Data;
            state.error = null;
        });
        builder.addCase(addEditUserAnalytics.rejected, (state, action) => {
            state.error = action.payload;
        });
        builder.addCase(getOneUserAnalytics.fulfilled, (state, action) => {
            state.userAnalytics = action?.payload;
        });
        builder.addCase(familyList.fulfilled, (state, action) => {
            state.familyListApi = action?.payload;
        });
        builder.addCase(addEditFamily.fulfilled, (state, action) => {
            state.familyListApi = action?.payload?.Data;
        });
        builder.addCase(getOneFamily.fulfilled, (state, action) => {
            state.familyListApi = action?.payload;
        });
    }
});

export default userAnalyticsSlice.reducer;

// user selector
export const selectUserAnalyticsList = (state) => state?.userAnalytics?.userAnalytics;
export const useUserAnalytics = () => {
    const userAnalytics = useSelector(selectUserAnalyticsList);
    return useMemo(() => userAnalytics, [userAnalytics]);
};

// family selector
export const selectFamilyList = (state) => state?.userAnalytics?.family;
export const useFamily = () => {
    const family = useSelector(selectFamilyList);
    return useMemo(() => family, [family]);
};